module.exports = __webpack_public_path__ + "img/aboservice-v6.ea4f20b0.jpg";